import type { JSX } from "solid-js";
import { Spinner } from "./Spinner";

interface Props extends JSX.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "outline";
  loading?: boolean;
}

export function Button(props: Props) {
  const cls = () =>
    `${props.variant === "outline" ? "btn-outline" : "btn-primary"} ${props.loading ? "!opacity-100" : ""} ${props.class ?? ""}`;
  return (
    <button
      type={props.type ?? "button"}
      {...props}
      class={cls()}
      disabled={props.disabled || props.loading}
      aria-busy={props.loading || undefined}
    >
      {props.loading ? (
        <span class="flex items-center justify-center">
          <Spinner />
          <span class="sr-only">Chargement</span>
        </span>
      ) : (
        props.children
      )}
    </button>
  );
}
